import React, { FC } from 'react'
import { IProduct } from '@shared/Types'
import { FormatDatetime2 } from '@lib/Helpers'
import { Box, Collapse, Divider, Typography } from '@mui/material'
import { TextOverflowDetector, UITextLineBreak } from '@shared/UIStyleds'
import { TryParseProductTags } from './helpers'
import VideoPlayer from './video-player'
import CreateMediaInfo from './create.media-info'
import { TextEditorPreview } from '@lib/Component/TextEditor'
import UIPlayerDescription from './ui.player.description'

const MediaInfoInstance = CreateMediaInfo<IProduct>([
  { key: 'Tags', size: { xs: 3 }, valueFormatter: (x) => TryParseProductTags(x).join(' • ') },
  { key: 'Location', size: { xs: 3 } },
  { key: 'Author', size: { xs: 3 } },
  { key: 'Copyrights', size: { xs: 3 } },
  { key: 'Submiited', size: { xs: 3 } },
  { key: 'Published', size: { xs: 3 } },
  { key: 'DateCreated', label: 'Created date', valueFormatter: (x) => FormatDatetime2(x, 'dddd, MMMM DD, YYYY'), size: { xs: 3 } }
])

interface IProps {
  product?: IProduct
  controlBar?: JSX.Element
}

const UIPlayer: FC<IProps> = (props) => (
  <div>
    <VideoPlayer value={props.product} />
    <Collapse in={!!props.product}>
      <Box sx={{ padding: '10px 0 24px' }}>
        {props.controlBar}
        <Divider sx={{ m: '12px 0 18px' }} />
        {/* <Typography component='p' variant='body1' sx={{ marginY: '10px' }}>
          <TextOverflowDetector maxHeight={50}>
            <UITextLineBreak>{props.product?.Description}</UITextLineBreak>
          </TextOverflowDetector>
        </Typography> */}
        <UIPlayerDescription product={props.product} />
        <MediaInfoInstance value={props.product} sx={{ mt: '20px' }} />
      </Box>
    </Collapse>
  </div>
)

export default UIPlayer
